import { type OperationResponse } from "../../../../common.ts";
import {
  omitPathParameters,
  replacePathParameters,
} from "../../../../utils.ts";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Paths from "./index.ts";
import type { TransferListSupportedResource } from "./getRows/responses.ts";

export const getSystemTransferListOperations = (client: AxiosInstance) => {
  const getRows = <
    T extends TransferListSupportedResource = TransferListSupportedResource,
  >(
    parameters: Paths.GetRows.QueryParameters & Paths.GetRows.PathParameters,
    data?: null | undefined,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.GetRows.Responses.$200<T>> => {
    const url = "/system/transfer-list/rows";
    return client.get(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      data: data,
      ...config,
    });
  };

  const manageRows = (
    parameters: Paths.ManageRows.PathParameters,
    data?: Paths.ManageRows.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.ManageRows.Responses.$200> => {
    const url = "/system/transfer-list/rows/manage";
    return client.put(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  return {
    getRows,
    manageRows,
  };
};
